import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  learnMore: css`
    display: block;
    font-size: 10px;
    padding-inline-end: 5px;
    button {
      text-transform: none;
      font-style: italic;
      font-size: 1em;
    }
  `,

  learnMoreLink: css`
    color: ${colors.blue80};
  `,

  inlineButton: css`
    button {
      text-transform: none;
    }
  `,
  // This style is used to allow the place bread crumbs to appear closer to the place autosuggest component
  placeInputWrapper: css`
    * > div[name='place'] {
      margin-bottom: 8px;
    }
  `,
  recordsType: css`
    div[class^='cellCss'] {
      padding-top: 0;
      padding-bottom: 10px;
      margin-top: -5px;
    }
    div {
      height: auto;
    }
  `,
}
